export const environment = {
  production: true,
  environment: "prd",
  // Confirmada 29-sep-2026 (Carlo/Roberto): apiconsentimiento.grupokaufmann.com, verificada en
  // vivo (responde con el formato de error real del backend, no un dominio inexistente).
  apiUrl: "https://apiconsentimiento.grupokaufmann.com",
  // Confirmado 30-sep-2026: en prod tipo_formulario.cod_tipo_formulario para el formulario
  // de otorgamiento es "ACEPTACION", no "CONSENT" (ese es el valor que usan QA/local -- son
  // catálogos distintos, no armonizados entre ambientes). Verificado en vivo: cod_tipo_formulario
  // =CONSENT devuelve 404 ERR_FORMULARIO_NO_VIGENTE en prod; =ACEPTACION responde bien.
  codTipoFormulario: "ACEPTACION",
};
